import { Stack, useTheme } from "@mui/material";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { FlatRowSwitch } from "web_myplann/Shared/Components/FlatRow/FlatRowSwitch";
import { SectionHeader } from "web_myplann/Shared/Components/SectionHeader";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import { MyPlannNavigationHeader } from "web_myplann/Shared/Header/MyPlannNavigationHeader";
import { useBiometryToggle } from "web_myplann/Shared/Hooks/useBiometryToggle";

export const SecurityPage = () => {
	const theme = useTheme();
	const { t } = useResource();
	const { hasBiometry, toggle, isPending } = useBiometryToggle();

	return (
		<MyPlannLayout
			disableContentPadding
			bgColor={theme.palette.surface.muted}
			topBar={
				<MyPlannNavigationHeader
					title={t(Resources.Security.title)}
					bgColor={theme.palette.background.paper}
					defaultRoute={Routing.Profile.More.path()}
				/>
			}
		>
			<Stack minHeight="100%">
				<SectionHeader title={t(Resources.Security.Sections.Login)} />
				<Stack bgcolor={theme.palette.background.paper}>
					<FlatRowSwitch
						label={t(Resources.Security.Biometry)}
						checked={hasBiometry}
						onChange={toggle}
						disabled={isPending}
						isLast
					/>
				</Stack>
			</Stack>
		</MyPlannLayout>
	);
};
